export const data: Record<
  string,
  { title: string; arAccountTitle: string; usAccountTitle: string }
> = {
  'pt-BR': {
    title: 'Dados das suas contas',
    arAccountTitle: 'Conta Argentina',
    usAccountTitle: 'Conta Global',
  },
  'en-US': {
    title: 'Your account details',
    arAccountTitle: 'Argentine Account',
    usAccountTitle: 'Global Account',
  },
  'es-ES': {
    title: 'Datos de tus cuentas',
    arAccountTitle: 'Cuenta Argentina',
    usAccountTitle: 'Cuenta Global',
  },
}
